import countdownTimer from '../../components/countdownTimer/countdownTimer';

const scholarshipOptionsInit = () => {
    const scholarshipOptions = document.querySelectorAll('.s-scholarship-options');
    scholarshipOptions.forEach(scholarshipOption => {
        /**
         * @type {HTMLElement}
         */
        const countdownEl = scholarshipOption.querySelector('[data-countdown-timer]');
        if (countdownEl) {
            try {
                const { countdownTimer: endDateString } = countdownEl.dataset;
                // Create the wrappers
                const countdownWrapper = document.createElement('div');
                const countdownText = document.createElement('p');
                countdownWrapper.classList.add('countdown-wrapper');
                countdownText.classList.add('countdown-text');
                countdownWrapper.appendChild(countdownText);
                countdownEl.appendChild(countdownWrapper);

                // Create the digits block
                const countdownDigits1 = document.createElement('span');
                countdownDigits1.classList.add('countdown-digits');
                const countdownUnit1 = document.createElement('span');
                countdownUnit1.classList.add('countdown-unit');

                // Clone the digits block 3 times
                const countdownDigits2 = countdownDigits1.cloneNode(true);
                const countdownDigits3 = countdownDigits1.cloneNode(true);
                const countdownUnit2 = countdownUnit1.cloneNode(true);
                const countdownUnit3 = countdownUnit1.cloneNode(true);

                // Add the digits block to the wrapper
                countdownText.appendChild(countdownDigits1);
                countdownText.appendChild(countdownUnit1);
                countdownText.appendChild(countdownDigits2);
                countdownText.appendChild(countdownUnit2);
                countdownText.appendChild(countdownDigits3);
                countdownText.appendChild(countdownUnit3);

                const countdownUnitArray =
                    countdownEl.querySelectorAll('.countdown-unit');
                const countdownDigitsArray =
                    countdownEl.querySelectorAll('.countdown-digits');

                const runCb = (dd, hh, mm, ss) => {
                    const addS = val => (val !== 1 ? 's' : '');
                    const timeArray = dd > 0 ? [dd, hh, mm] : [hh, mm, ss];
                    const unitArray =
                        dd > 0
                            ? [
                                `day${addS(dd)}`,
                                `hour${addS(hh)}`,
                                `minute${addS(mm)}`
                            ]
                            : [
                                `hour${addS(hh)}`,
                                `minute${addS(mm)}`,
                                `second${addS(ss)}`
                            ];

                    countdownDigitsArray.forEach((digits, index) => {
                        const countdownUnit = countdownUnitArray[index];
                        const unit = unitArray[index];
                        if (countdownUnit.textContent !== unit) {
                            countdownUnit.textContent = unit;
                        }

                        const toStringWithZero = num =>
                            `${num < 10 ? '0' : ''}${num}`;
                        const timeStrings = toStringWithZero(timeArray[index]).split('');

                        if (timeStrings.length !== digits.children.length) {
                            while (digits.lastElementChild) {
                                digits.removeChild(digits.lastElementChild);
                            }
                            for (let i = 0; i < timeStrings.length; i += 1) {
                                const countdownDigit =
                                    document.createElement('span');
                                countdownDigit.classList.add('countdown-digit');
                                const countdownDigitChild =
                                    document.createElement('span');
                                countdownDigit.appendChild(countdownDigitChild);
                                digits.appendChild(countdownDigit);
                            }
                        }
                        const countdownDigitSpans = digits.querySelectorAll('.countdown-digit span');
                        timeStrings.forEach((timeString, i) => {
                            const span = countdownDigitSpans[i];
                            if (span.textContent !== timeString) {
                                countdownDigitSpans[i].textContent = timeString;
                            }
                        });
                    });
                };

                runCb(0, 0, 0, 0);
                countdownTimer(endDateString, runCb);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(error);
            }
        }
    });
};

document.addEventListener('DOMContentLoaded', scholarshipOptionsInit);
